import { render } from "./EditTweetPopup.vue?vue&type=template&id=fe72a8c8"
import script from "./EditTweetPopup.vue?vue&type=script&lang=js"
export * from "./EditTweetPopup.vue?vue&type=script&lang=js"

import "./EditTweetPopup.vue?vue&type=style&index=0&id=fe72a8c8&lang=scss"
script.render = render

export default script